<div fxShow fxHide.lt-md>
    <ng-container *ngTemplateOutlet="desktopMenu"></ng-container>
</div>
<div fxHide fxShow.lt-md>
    <ng-container *ngTemplateOutlet="mobileMenu"></ng-container>
</div>

<ng-template #desktopMenu>
    <mat-toolbar class="mat-display-1" fxLayoutAlign="space-between">
        <div fxLayoutAlign="center center">
            <div class="links">
                <div fxLayoutGap="8%">
                    <ng-container *ngIf="isLoggedIn">
                        <a *ngFor="let route of routes" routerLinkActive="active"
                           [routerLink]="route.path">
                            {{ route.name }}
                        </a>
                    </ng-container>
                    <a href="https://shop.heringberlin.com" target="_blank" i18n="@@site-menu_entry-b2c">B2C</a>
                </div>
            </div>
        </div>

        <div class="hering-logo">
            <button mat-icon-button routerLink="/" title="Stefanie Hering - Berlin Logo">
                <mat-icon class="hering-icon" svgIcon="hering-logo"></mat-icon>
            </button>
        </div>

        <div class="icons" fxLayout fxLayoutGap="2.5%">
            <div fxLayoutAlign="space-evenly" *ngIf="isLoggedIn">
                <app-searchbar></app-searchbar>
                <button class="quote-list" (click)="onOpenQuoteList()" mat-icon-button>
                    <mat-icon [svgIcon]="hasNonEmptyQuotes ? 'hering-quote-list' : 'hering-quote-list-empty'">
                    </mat-icon>
                </button>
                <button mat-icon-button [matMenuTriggerFor]="accountMenu">
                    <mat-icon svgIcon="hering-account"></mat-icon>
                </button>
            </div>
            <div *ngIf="currentLanguage">
                <ng-template *ngIf="currentLanguage && languages" ngFor let-language [ngForOf]="languages">
                    <button class="language" *ngIf="language.label !== currentLanguage.label"
                            (click)="switchLanguage(language)" mat-icon-button>
                        <mat-icon class="language-logo" *ngIf="language.label === 'EN'"
                                  svgIcon="hering-language-german"></mat-icon>
                        <mat-icon class="language-logo" *ngIf="language.label === 'DE'"
                                  svgIcon="hering-language-english"></mat-icon>
                    </button>
                </ng-template>
            </div>
        </div>
    </mat-toolbar>
</ng-template>

<ng-template #mobileMenu>
    <mat-toolbar ngClass.gt-md="bottom-space" fxLayoutAlign="space-between">
        <button *ngIf="isLoggedIn" class="quote-list" (click)="onOpenQuoteList()" mat-icon-button>
            <mat-icon [svgIcon]="hasNonEmptyQuotes ? 'hering-quote-list' : 'hering-quote-list-empty'"></mat-icon>
        </button>

        <button mat-icon-button routerLink="/" title="Stefanie Hering - Berlin Logo">
            <mat-icon class="hering-icon" svgIcon="hering-logo"></mat-icon>
        </button>

        <button (click)="onOpenSiteMenu()" class="logo" fxHide fxShow.lt-md mat-icon-button>
            <mat-icon svgIcon="hering-burger-menu"></mat-icon>
        </button>
    </mat-toolbar>
</ng-template>

<mat-menu #languageMenu="matMenu">
    <ng-template *ngIf="currentLanguage && languages" ngFor let-language [ngForOf]="languages">
        <button (click)="switchLanguage(language)" *ngIf="language.storeCode !== currentLanguage.storeCode"
                mat-menu-item>{{language.label}}
        </button>
    </ng-template>
</mat-menu>
<mat-menu #accountMenu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">
    <button (click)="logout()" mat-menu-item i18n="@@header_account-menu-entry-logout">Logout</button>
</mat-menu>
